export const environment:Env = {
  production: true,
  apiURL: 'https://gateway-scheduler.additionfi.com/v1',
  settings: '/settings/{{category}}',
  completionEndPoint: '/events/create-appointment',
  queueEndPoint: '/events/create-queue-item',
  serviceEndPoint: '/branches/{{branchID}}/services',
  brancheEndPoint: '/branches',
  availabilityEndPoint: '/staff/{{branchID}}/availabilities',
  cancelEndPoint: '/events/{{eventID}}/cancel',
  appointmentEndPoint: '/events/appointments/scheduled/',
  checkinEndPoint: '/branches/{{branchID}}/customer-check-in',
  eventsEndPoint: '/events/{{branchID}}/tv-queue',
  PINEndPoint: '/admin/kiosk/log-in'
}
